module.exports = __webpack_public_path__ + "img/right-team-avatar.d7f2ed28.svg";